export default __webpack_public_path__ + "static/media/escolher-o-imovel.21d71fb8.png";